import { ThreeBounce } from 'better-react-spinkit';
import { Spinner } from 'components/spinner/Spinner';
import React from 'react';

type PopoutMenuFooterProps = {
  handlePrimaryButtonClick?: () => void;
  handleSecondaryButtonClick?: () => void;
  handleTertiaryButtonClick?: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  tertiaryButtonText?: string;
  primaryBtnColor?: string;
  secondaryBtnColor?: string;
  isSubmitting?: boolean;
};

export const PopoutMenuFooter: React.FC<PopoutMenuFooterProps> = ({
  handlePrimaryButtonClick,
  handleSecondaryButtonClick,
  handleTertiaryButtonClick,
  primaryButtonText,
  secondaryButtonText,
  tertiaryButtonText,
  primaryBtnColor,
  secondaryBtnColor,
  isSubmitting,
}) => {
  const btnColour = primaryBtnColor ? primaryBtnColor : 'BtnOrange';
  const secondaryBtnColour = secondaryBtnColor ? secondaryBtnColor : 'BtnGrey';

  return (
    <div className="PopoutMenuFooter">
      {tertiaryButtonText && handleTertiaryButtonClick &&
        <button
          className="Btn BtnGrey TertiaryButton"
          onClick={handleTertiaryButtonClick}
        >
          {tertiaryButtonText}
        </button>
      }
      {secondaryButtonText && handleSecondaryButtonClick && 
        <button
          className={'Btn SecondaryButton ' + secondaryBtnColour}
          onClick={handleSecondaryButtonClick}
        >
          {secondaryButtonText}
        </button>
      }
      <button
        type="button"
        className={'Btn PrimaryButton ' + btnColour}
        onClick={handlePrimaryButtonClick && handlePrimaryButtonClick}
        disabled={isSubmitting ? true : false}
      >
        {isSubmitting ? (
          <ThreeBounce size={10} color={'#ffffff'} />
        ) : (
          primaryButtonText
        )}
      </button>
    </div>
  );
};
